import { useCallback, useEffect } from 'react';

/**
 * Hook returns focus back to the game canvas on mouse down event

 */
export const useGameFocus = (canvasRef) => {
    const handleMouseDown = useCallback(() => {
        window.focus();
        canvasRef.current?.focus();
    }, [canvasRef]);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        if (canvas.tabIndex < 0) {
            canvas.tabIndex = 0;
        }

        canvas.addEventListener('pointerdown', handleMouseDown);

        const onWindowFocus = () => {
            setTimeout(() => canvas.focus(), 0);
        };

        window.addEventListener('focus', onWindowFocus);

        return () => {
            canvas.removeEventListener('pointerdown', handleMouseDown);
            window.removeEventListener('focus', onWindowFocus);
        };
    }, [canvasRef, handleMouseDown]);
};
